/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ServiceCreate = {
    properties: {
        serviceAddressId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        meterId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        type: {
            type: 'ServiceTypeEnum',
            isRequired: true,
        },
    },
};